<template>
  <div v-if="isLoading" class="loader-container">
    <preloader />
  </div>

  <div v-else>
    <header class="timer d-flex justify-content-center align-items-center flex-column" :style="headerStyle"
      v-if="activePromotion && !$route.meta.hideHeader">
      <div class="container text-center">
       <div class="d-flex gap-3 flex-wrap justify-content-center">
          <p>{{ promotions?.text }}</p>
          <p class="mb-3">
            <strong> {{ saleEndFormatted }} </strong>  
          </p>
       </div>

        <p > <span class="fw-semibold">  {{ $t('endsIn') }} </span>  <span class="fw-bold"> {{ timeLeft }} </span></p>
      </div>
    </header>

    <go-top />
    <WhatsAppIcon v-show="showWhatsAppIcon" />
    <router-view />
  </div>
</template>

<script>
import Preloader from "./components/Layout/Preloader.vue";
import GoTop from "./components/Layout/GoTop.vue";
import WhatsAppIcon from "./components/Layout/WhatsAppIcon.vue";

export default {
  components: {
    Preloader,
    GoTop,
    WhatsAppIcon
  },
  data() {
    return {
      scrollY: 0,
      isLoading: true,
      showWhatsAppIcon: true,
      // timeLeft: "2h 26m 00s", // Initial placeholder
      timeLeft: "Calculating...", // Initial placeholder
      countdownInterval: null,
      //saleEndTime: new Date("2025-03-04T08:28:00.000000Z"), // Change this to your desired end time
      countdownInterval: null,
    };
  },
  watch: {
    "$i18n.locale": {
      handler(newLanguage) {
        document.querySelector("html").setAttribute("lang", newLanguage);
        this.$store.dispatch("GlobalData");
      },
      immediate: true,
    },
  },
  computed: {
    headerStyle() {
      return {
        position: this.scrollY > 50 ? 'fixed' : 'sticky', // Change scrollY value to suit your needs
        width: '100%',
        zIndex: 1000, // Optional, to ensure it stays above other content
      };
    },

    promotions() {
      return this.$store.getters.getPromotion
    },

    //Sale End date
    saleEndTime() {
      if (this.promotions && this.promotions.ends_at) {
        return new Date(this.promotions.ends_at);
      }
      return null; // Fallback if no promotion data
    },

    saleEndFormatted() {
      if (!this.saleEndTime) return "No active promotion";
      return this.saleEndTime.toLocaleString("en-GB", {
       // timeZone: "UTC",  
        weekday: "long",
        day: "2-digit",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    },
  },
  methods: {
    handleScroll() {
      this.scrollY = window.scrollY;
    },
    updateCountdown() {
      const now = new Date();
      const remainingTime = Math.floor((this.saleEndTime - now) / 1000); // Get remaining seconds

      if (remainingTime <= 0) {
        clearInterval(this.countdownInterval);
        this.timeLeft = "Sale Ended!";
        return;
      }

      const days = Math.floor(remainingTime / (3600 * 24));
      const hours = Math.floor((remainingTime % (3600 * 24)) / 3600); // Remaining hours
      const minutes = Math.floor((remainingTime % 3600) / 60); // Remaining minutes
      const seconds = remainingTime % 60; // Remaining seconds

      if (remainingTime / (3600 * 24) > 1) {
        this.timeLeft = `${days}days ${hours}h ${minutes}m ${seconds}s`;
      } else {
        this.timeLeft = `${hours}h ${minutes}m ${seconds}s`;
      }
      // const hours = Math.floor(remainingTime / 3600);
      // const minutes = Math.floor((remainingTime % 3600) / 60);
      // const seconds = remainingTime % 60;
      
     // this.timeLeft = `${days}day ${hours}h ${minutes}m ${seconds}s`;
    },
  
    updateHtmlLangAttribute() {
      // Get the stored language from local storage
      const storedLanguage = localStorage.getItem("language");
      // Set the lang attribute of the html tag
      document
        .querySelector("html")
        .setAttribute("lang", storedLanguage || "en");
    },
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
 
    this.updateHtmlLangAttribute();
    //update counting 
    this.updateCountdown(); // Run immediately to avoid delay
    this.countdownInterval = setInterval(this.updateCountdown, 1000);

    //Get global data

    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    clearInterval(this.countdownInterval);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss">
.timer {
  position: sticky;
  top: 0;
  width: 100%;
  padding: 25px 0;
  background: #94ad04;
  z-index: 1000;
  height: 100px;
  p {
    color: #fff;
    font-size: 20px;
    line-height: 1.5;
  }
}

@media screen and (max-width : 992px) {
  .timer {
    p {
      font-size: 13px;
    }
  }
}
</style>
